module.exports = __webpack_public_path__ + "img/DECHubUserPrivacyAgreementEN.29113d36.jpg";